module.exports = __webpack_public_path__ + "img/5.1a7d516a.jpg";